Monitoring.Views ||= {}

class Monitoring.Views.ReviewQueueDefinitionsView extends Backbone.View
  template: JST["backbone/templates/moderation/review_queue_definitions/review_queue_definitions"]

  events :
    'click #new-review-queue-definition': 'onClickNewReviewQueueDefinition'

  initialize: (@options = {}) ->
    @reviewQueueDefinitions = @options.reviewQueueDefinitions
    @availableTopics        = @options.available_topics
    @availableTags          = @options.available_tags
    @availableGroups        = @options.available_groups
    @availableSubtypes      = @options.available_subtypes
    @allSubtypes            = @options.all_subtypes
    @availableUsers         = @options.available_users
    @availableUsersGroups   = @options.available_users_groups

  render: =>
    sortableContext = @$el.find('table.sortable').data('bootstrap-sortable-context')
    @listView.remove() if @listView
    @editView.remove() if @editView
    @$el.html(@template(@))
    @renderList()
    if sortableContext
      @$el.find('table.sortable').data('bootstrap-sortable-context', sortableContext)
    $.bootstrapSortable applyLast: true
    @

  renderList: =>
    @listView.remove() if @listView
    @listView = new Monitoring.Views.ReviewQueueDefinitionListView(
      _.extend({ reviewQueueDefinitions: @reviewQueueDefinitions }, @_getDefinitionParams())
    )
    @$el.find('.list-view-container').append(@listView.render().el)
    @listenTo(@listView, 'edit', @renderEdit)

  onClickNewReviewQueueDefinition: ->
    @renderEdit()

  renderEdit: (reviewQueueDefinition = new Monitoring.Models.ReviewQueueDefinition) ->
    @editView.remove() if @editView
    @editView = new Monitoring.Views.ReviewQueueDefinitionEditView(
      _.extend({ reviewQueueDefinition: reviewQueueDefinition }, @_getDefinitionParams())
    )
    @$el.find('.edit-view-container').html(@editView.render().el)
    @editView.show()
    @listenTo(@editView, 'afterSave', @afterSave)

  _getDefinitionParams: ->
    {
      availableTopics: @availableTopics
      availableTags: @availableTags
      availableGroups: @availableGroups
      availableSubtypes: @availableSubtypes
      allSubtypes: @allSubtypes
      availableUsers: @availableUsers
      availableUsersGroups: @availableUsersGroups
    }

  afterSave: (definition) ->
    index = @reviewQueueDefinitions.indexOf(definition)
    if index >= 0
      @reviewQueueDefinitions.remove(definition);
      @reviewQueueDefinitions.add(definition, at: index);
    else
      @reviewQueueDefinitions.push(definition)
    @render()
